import { useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "./help.css";

const Help = () => {
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, []);

  return (
    <div className="help-page">
      <Header title="Help" buttons={[{ to: "/", label: "Back" }]} />

      <main className="help-main">
        <section>
          <h2>About ScanTAPS</h2>
          <p>
            ScanTAPS is a digital Lost & Found system designed for ASU. It helps
            students easily tag, protect, and locate their belongings using NFC
            stickers or QR codes linked to their accounts.
          </p>
        </section>

        <section>
          <h2>How It Works</h2>
          <ul>
            <li>
              Attach a ScanTAPS tag or QR sticker to your item (like ID card,
              bottle, laptop, etc.).
            </li>
            <li>Register your item on the ScanTAPS website or mobile app.</li>
            <li>
              If someone finds your item, they can scan the tag to instantly
              notify you.
            </li>
            <li>
              You can track your items, mark them as lost, or update ownership
              information anytime.
            </li>
          </ul>
        </section>

        <section>
          <h2>FAQ</h2>
          <ul>
            <li>
              <span className="faq-q">Q: What if I lose my item?</span>
              <span>
                A: Go to your ScanTAPS dashboard and mark it as <i>"Lost"</i>.
                If someone scans it, you'll get an instant alert via email.
              </span>
            </li>
            <li>
              <span className="faq-q">Q: How do I claim an item I found?</span>
              <span>
                A: Just scan the QR/NFC tag — the system automatically connects
                you with the rightful owner.
              </span>
            </li>
            <li>
              <span className="faq-q">
                Q: Can non-ASU users access this system?
              </span>
              <span>
                A: No, this system is exclusive to ASU users only. You must have
                an ASU login to access the system.
              </span>
            </li>
          </ul>
        </section>

        <section>
          <h2>Need Help?</h2>
          <div className="contact-box">
            <p>
              📧 <b>Email:</b>{" "}
              <a href="mailto:support@scantaps.com">support@scantaps.com</a>
            </p>
            <p>
              📞 <b>Phone:</b> +1 (480) 364-0266
            </p>
            <p>
              🏫 <b>Office:</b> Arizona State University, Tempe Campus
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Help;
